export default __webpack_public_path__ + "static/media/exchange.bd73c271.png";